import { mountInviteDock } from '@bn-games/ui-shell';
import type { Scene } from './types.js';

export interface SocialDockOptions {
  readonly serverUrl: string;
  /** True while an online game is being played; Accept then asks first. */
  readonly isGameInProgress: () => boolean;
}

export interface SocialDock {
  /** Call on every scene change: the main menu gets the full card, every other scene the pill. */
  showScene(scene: Scene): void;
}

/**
 * Mounts the page-lifetime invite dock once at boot. The app starts on the
 * main menu, so the dock starts `expanded`.
 */
export function mountSocialDock(opts: SocialDockOptions): SocialDock {
  const dock = mountInviteDock({
    serverUrl: opts.serverUrl,
    density: 'expanded',
    isGameInProgress: opts.isGameInProgress,
  });
  return {
    showScene(scene) {
      dock.setDensity(scene === 'menu' ? 'expanded' : 'compact');
    },
  };
}
